import { Box } from "@outschool/backpack";
import { ContentfulTutoringPageQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { SimilarArticlesMagnetPageCarousel } from "@outschool/ui-components-website";
import React from "react";

import PageSectionTitle from "./PageSectionTitle";

const TutoringRecommendedArticles = ({
  articles
}: {
  // @ts-ignore TS(2339): Property 'items' does not exist on type '{ __typen... Remove this comment to see the full error message
  articles: ContentfulTutoringPageQuery["contentfulTutoringPageCollection"]["items"][number]["articlesCollection"]["items"][number];
}) => {
  const { t } = useTranslation(
    "client\\components\\tutoring\\TutoringPage\\TutoringRecommendedArticles"
  );
  return (
    <Box
      sx={{
        "& > *": { padding: "0 !important", margin: "-5rem 0 0 0" },
        "& h4": { paddingBottom: "0 !important" }
      }}
    >
      <SimilarArticlesMagnetPageCarousel
        title={<PageSectionTitle title={t("Recommended articles")} />}
        articles={articles}
        carouselSx={{ maxWidth: "100%" }}
      />
    </Box>
  );
};
export default TutoringRecommendedArticles;
